import shape02 from "../../../Assets/img/shape02.svg";
import shape05 from "../../../Assets/img/shape05.svg";
import shape06 from "../../../Assets/img/shape06.svg";
import { politicas_privacidad, politicas_privacidad_uy } from '../diccionario';
import useSEOConfig from '../../../hooks/seo/useSEOConfig';
import { Navbar } from "../Components/Navbar";
import { useConfig } from "../../../context/ConfigContext";
import { Link, useLocation } from "react-router-dom";
import { buscarTextoSeo } from "../../../utils/buscarTextoSeo";

export const PoliticasPrivacidad = () => {

    const { origen: parametros, config } = useConfig()

    const politicas = config.pais === "UY" ? politicas_privacidad_uy : politicas_privacidad

    const politicas_filtradas = (): {
        titulo: string;
        content: JSX.Element;
    }[] => {
        switch (parametros?.origen) {
            case "YPFRUTA":
                return politicas.filter(item => item.titulo !== "Preguntas y sugerencias:" && item.titulo !== "Botón de arrepentimiento:")
            default:
                return politicas
        }
    }


    const location = useLocation();
    const textoSeo = buscarTextoSeo(location.pathname, config.pais);

    useSEOConfig(
        {
            title: textoSeo?.title ?? "Segurarse - Políticas de Privacidad",
            description: textoSeo?.description ?? "La transparencia es uno de nuestros pilares principales, nos comprometemos a ofrecer experiencias seguras. Resguardamos los datos a través de protocolos de seguridad.",
            tituloCompleto: !!textoSeo,
            keywords:
                config.pais === "UY" ?
                    "Seguros de Auto, Seguro para moto, Seguros económicos, Cotizar seguro de auto, Seguro online, Seguro de Hogar, Aseguradoras, Seguros Mapfre, Seguro flota, Cotizar seguro, Seguro San Cristóbal, Seguro Sancor"
                    :
                    "Seguros de Auto, Seguro para moto, Seguros económicos, Cotizar seguro de auto, Seguro Mala praxis, Seguro online, Asistencia al viajero, Aseguradoras, Seguros rivadavia, Seguro flota, Cotizar seguro",
            ogTitle: "Segurarse - Políticas de Privacidad",
            ogDescription: "La transparencia es uno de nuestros pilares principales, nos comprometemos a ofrecer experiencias seguras. Resguardamos los datos a través de protocolos de seguridad.",
            twitterTitle: "Segurarse - Políticas de Privacidad",
            twitterDescription: "La transparencia es uno de nuestros pilares principales, nos comprometemos a ofrecer experiencias seguras. Resguardamos los datos a través de protocolos de seguridad."
        }
    )
    return (
        <>
            <Navbar rubro='auto' />

            <main>
                <div className="position-relative pt-45 pb-25 pt-lg-80 pb-lg-35">
                    <img className="d-none d-lg-block pos02" src={shape02} alt='' />
                    <div className="container">
                        <h1 className="ff-mukta fw-bold fs-30 fs-lg-36 lh-lg-1 text-black text-center text-lg-start mb-10">
                            {config.pais === "UY" ?
                                "Políticas de privacidad y protección de datos personales"
                                :
                                " Políticas de privacidad"
                            }
                        </h1>
                    </div>
                </div>

                <div className='container'>
                    <div className='row'>
                        <div className='gx-5 gx-lg-4 col-lg-9'>
                            {
                                politicas_filtradas().map(item => (
                                    <div key={item.titulo}>
                                        <h3 className="mb-1 fs-16 fw-bold text-primary">
                                            {item.titulo}
                                        </h3>
                                        <p className='text-black mb-25 text-justify'>
                                            {item.content}
                                        </p>
                                    </div>
                                ))
                            }
                        </div>
                    </div>

                </div>

                <div className="bg-f4 py-30 py-lg-50 position-relative">
                    <img className="d-none d-lg-block pos07 bottom-0" src={shape05} alt='' />
                    <img className="d-none d-lg-block pos06" src={shape06} alt='' />
                    <div className="container px-lg-5">
                        {
                            (parametros!.origen === "SEGURARSE") ?
                                <div className="row justify-content-evenly">
                                    <div className="col-lg-auto text-center text-lg-start">
                                        <h2 className="ff-mukta fw-bold fs-30 fs-lg-40 text-black mb-lg-1">
                                            ¿No resolvimos{" "}<br className="d-sm-none" />
                                            tu consulta?
                                        </h2>
                                        <p className="fw-bold fs-25 fs-lg-25 text-primary mb-18 mb-lg-0">¡Estamos para vos!</p>
                                    </div>
                                    <div className="col-lg-auto text-center text-lg-left">
                                        <Link
                                            to="/contacto"
                                            className="transition-base d-inline-block w-250p py-12 rounded-3 fs-22 fs-lg-24 fw-bold lh-1 text-center bg-primary bg-lg-gray-dark hover-bg-primary text-white"
                                        >
                                            CONTACTO
                                        </Link>
                                    </div>
                                </div>
                                :
                                <div style={{ height: "140px" }} />
                        }
                    </div>
                </div>
            </main>
        </>
    )
}
